export * from '@polyai/common/types/api';

export * from './resources/accounts/types';
export * from './resources/balance/types';
export * from './resources/config/types';
export * from './resources/conversation/types';
export * from './resources/functions/types';
export * from './resources/handoff/types';
export * from './resources/knowledgeBase/types';
export * from './resources/payments/types';
export * from './resources/phoneNumber/types';
export * from './resources/projects/types';
export * from './resources/questionnaire/types';
export * from './resources/sampleProjects/types';
export * from './resources/telephony/types';
export * from './resources/topics/types';
export * from './resources/variantManagement/types';
export * from './resources/webRTC/types';

export enum LOGGER_TYPE {
  ACCOUNT = 'accountLogger',
  ANALYTICS = 'analyticsLogger',
  CONVERSATIONS = 'conversationsLogger',
  AGENT_CONFIG = 'agentConfigLogger',
  PROJECT_SETTINGS = 'projectSettingsLogger',
  PROJECT = 'projectLogger',
  FEATURES = 'featuresLogger',
  USER_MANAGEMENT = 'userManagementLogger',
  REDUX_STORAGE = 'reduxStorageLogger',
  REACT_ERROR = 'reactError',
  JUPITER = 'jupiter',
  AUDIO_MANAGEMENT = 'audioManagement',
  AGENT_STREAM = 'agentStreamLogger',
  QUERY_CLIENT = 'queryClientLogger',
}
